(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["gf-product-filmstrip"] && !Shopify.designMode) return;
  try {
    /**
   * The media band's lightbox. An on-demand reveal, which is one of the three things
   * motion is permitted for; the fade is the theme's own speed token, so
   * prefers-reduced-motion already collapses it to zero.
   */
  if (!customElements.get('gf-filmstrip')) {
    customElements.define(
      'gf-filmstrip',
      class GfFilmstrip extends HTMLElement {
        connectedCallback() {
          const data = this.querySelector('[data-gf-media]');
          this.media = data ? JSON.parse(data.textContent) : [];
          this.dialog = this.querySelector('[data-gf-lightbox]');
          this.image = this.querySelector('[data-gf-lightbox-image]');
          this.counter = this.querySelector('[data-gf-lightbox-counter]');
          this.index = 0;

          if (!this.dialog || !this.media.length) return;

          this.addEventListener('click', this.handleClick);
          this.dialog.addEventListener('keydown', this.handleKeydown);
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.handleClick);
          this.dialog?.removeEventListener('keydown', this.handleKeydown);
        }

        handleClick = (event) => {
          const cell = event.target.closest('[data-gf-index]');
          if (cell) {
            this.open(Number(cell.dataset.gfIndex));
            return;
          }

          const step = event.target.closest('[data-gf-step]');
          if (step) {
            // The controls sit inside the backdrop, which closes on click.
            event.stopPropagation();
            this.step(Number(step.dataset.gfStep));
            return;
          }

          if (event.target.closest('[data-gf-close]') || event.target === this.dialog) {
            this.dialog.close();
          }
        };

        handleKeydown = (event) => {
          if (event.key === 'ArrowRight') this.step(1);
          if (event.key === 'ArrowLeft') this.step(-1);
        };

        open(index) {
          this.index = index;
          this.render();
          this.dialog.showModal();
        }

        step(delta) {
          const total = this.media.length;
          this.index = (this.index + delta + total) % total;
          this.render();
        }

        render() {
          const item = this.media[this.index];
          if (!item) return;
          this.image.src = item.src;
          this.image.alt = item.alt || '';
          // Each shot has its own ratio, so the intrinsic size travels with the src.
          if (item.width) this.image.width = item.width;
          if (item.height) this.image.height = item.height;
          const pad = (n) => String(n).padStart(2, '0');
          this.counter.textContent = `${pad(this.index + 1)} / ${pad(this.media.length)}`;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
